import MenuLabel from './menu-label.element.js';

export default MenuLabel;

MenuLabel.define('wje-menu-label', MenuLabel);
